$(document).ready(function () {
    $('.switch-button.toggle .switch-month, .switch-button.top').on('click', function () {
        $('.switch-button .active.toggle').css({"right": "unset", "left": "0px", "transition": "all 0.3s"});
        $('.switch-button-case.switch-month').css({"color": "white"});
        $('.switch-button-case.switch-year').css({"color": "black"});
        $('.value.price-per-month').css({"display": "block"});
        $('.value.price-per-year').css({"display": "none"});
        $('.active.switch-month').show();
        $('.active.switch-year').hide();
    });

    $('.switch-button.toggle .switch-year, .switch-button.bottom').on('click', function () {
        $('.switch-button .active.toggle').animate({left: "50%"}, 10);
        $('.switch-button-case.switch-year').css({"color": "white"});
        $('.switch-button-case.switch-month').css({"color": "black"});
        $('.value.price-per-month').css({"display": "none"});
        $('.value.price-per-year').css({"display": "block"});
        $('.active.switch-month').hide();
        $('.active.switch-year').show();
    });

    $('.voucher').on('click', function () {
        $('.voucher-box input').css({"left": "16px"});
        $('.voucher-box button').css({"left": "156px"});
        $(this).hide();
        $('.no-voucher').show();
    });

    $('.no-voucher').on('click', function () {
        $('.voucher-box input').css({"left": "-190px"});
        $('.voucher-box button').css({"left": "-50px"});
        $(this).hide();
        $('.voucher').show();
    });


    // Scroll
    if ($('.dashboard-list-box').hasClass('scrollable')) {
        var hash = location.hash;
        location.hash = '';
        if(hash[1] !== undefined){
            $('html, body').animate({scrollTop: $(hash).offset().top - 130}, 900);
        }
    }

});

function readURL(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
            $('.uploaded-image label').css({"background-image": "url("+ e.target.result +")"});
        };

        reader.readAsDataURL(input.files[0]);
    }
}